
module.controller('autoSendFundsCtrl', ['$scope', '$http', '$state', '$stateParams', 'recurringTransferService', 'cacheService', 'Transform', 'Session', 'memberService', 'baseURI', 'OVERLAY', 'DAY_OF_WEEK', 'DAY_OF_MONTH', 'FREQUENCY_OPTIONS',
  function ($scope, $http, $state, $stateParams, recurringTransferService, cacheService, Transform, Session, memberService, baseURI, OVERLAY, DAY_OF_WEEK, DAY_OF_MONTH, FREQUENCY_OPTIONS){
    var createRecurringUrl = baseURI + 'card/transfer/auto';
    var editRecurringUrl   = baseURI + 'card/transfer/auto/';
    var searchUrl          = baseURI + 'cardholder/search/';
    var recurringId        = $stateParams.recurringId || null;
    var transfer;

    var sourceCard = {
      Name: 'Your ' + $scope.brand.commonProgramName,
      Id: 0
    };

    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to process the transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

    $scope.scheduleText = 'Select Schedule';
    $scope.overlay = OVERLAY['member.home.send/recurring'];
    $scope.formData = {};
    $scope.formData.Source = {};
    $scope.transferTo = {};
    $scope.searchInput = {};
    $scope.searchInput.memberSearched = '';
    $scope.memberResult = {};
    $scope.memberType = 'Cards';
    $scope.attempted = false;
    $scope.searchLoading = false;

    $scope.memberTypes = {
      'sub': 'Cards',
      'favorites': 'Favorites',
      'phone': 'Phone Contacts'
    };

    // Datepicker
    $scope.datePicker           = {};
    $scope.datePicker.day1      = {};
    $scope.datePicker.day2      = {};
    $scope.datePicker.dateSelect= {};
    $scope.dayOptions           = [];
    $scope.dateOptions          = [];
    $scope.frequencyOptions     = FREQUENCY_OPTIONS;

    // Search in step1
    $scope.search = function(value){
      if(value.length > 2 || value === ''){
        $scope.searchLoading = true;
        $http.get(searchUrl + encodeURI(value))
          .then(function (resp){
            var data = resp.data;
            if(value == $scope.searchInput.memberSearched){
              if(data.Data){
                $scope.memberType = memberService.getType(data.Data[0].Type);
                $scope.memberResult = data.Data;
              } else {
                $scope.memberResult = [];
              }
            }
          }).catch(function (error){
            console.log('error', error);
          }).then(function (){
            $scope.searchLoading = false;
          });
      }
    };

    // Creates an array of member types (favorites, subs)
    $scope.groupMembers = function(){
      var groupMembers = [];

      angular.forEach($scope.memberResult, function (member, key){
        if(groupMembers.indexOf(member.Type) == -1){
          groupMembers.push(member.Type);
        }
      });

      return groupMembers;
    };

    // remove recurring send transfer
    $scope.removeTransfer = function(){
      $http.delete(baseURI + 'card/transfer/auto/' + recurringId).then(function (data){
        cacheService.clear('autoTransfer');
        $state.go('member.home.transfers/manage.list');
      });
    };

    // Called on frequency selector change event
    $scope.changeFreq = function(){
      var freqOptions = recurringTransferService.setDayOptions($scope.datePicker.frequency.key);
      $scope.dayOptions = freqOptions.dayOptions;
      $scope.datePicker.day1 = freqOptions.day1;
      $scope.datePicker.day2 = freqOptions.day2;

      var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
      $scope.dateOptions = dateOptions;
      $scope.datePicker.dateSelect = dateOptions[0];

      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // Called on day1 selector change event
    $scope.changeDay1 = function(){
      var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
      $scope.dateOptions = dateOptions;
      $scope.datePicker.dateSelect = dateOptions[0];

      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // Called on day2 selector change event
    $scope.changeDay2 = function(){
      var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
      $scope.dateOptions = dateOptions;
      $scope.datePicker.dateSelect = dateOptions[0];

      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // Called on date selector change event
    $scope.changeDate = function(){
      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // CH clicked on memberResult index
    $scope.selectMember = function(member){
      getBanks();
      $scope.transferTo = member;
      $state.go('member.home.send/recurring.step2');
    };

    // Validation for step2
    $scope.attemptSubmission = function (formData){
      if(formData.$valid){
        $scope.alert.errorShown = false;
        if(recurringId){
          $state.go('member.home.send/recurring/edit.step2', {recurringId: recurringId});
        } else {
          $state.go('member.home.send/recurring.step3');
        }
      } else {
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      }
    };

    // Review and submit
    $scope.processForm = function(formData){
      $scope.loading = true;
      var transferTo = $scope.transferTo;
      formData.ToType = transferTo.Type;

      // Edit RecurringId transfer
      formData.FromBankAccountId  = formData.Source.Id || 0;
      formData.StartDate          = $scope.datePicker.dateSelect.formattedDate || transfer.TransferStartDate;

      // Set form fields from datepicker
      formData.FrequencyType      = $scope.datePicker.frequency.key;
      formData.FrequencyDay1      = $scope.datePicker.day1.key;
      formData.FrequencyDay2      = $scope.datePicker.day2.key;

      formData.TransferContinuity = 'C';

      // Check transfer type
      switch(formData.ToType){
        case 'favorites':
        case 'sub':
        case 'akimbo':
        case 'phone':
          formData.ToUsername = transferTo.Username;
          break;
        case 'email':
          formData.ToEmail = transferTo.Email;
          break;
        case 'fb':
          formData.ToFbId = transferTo.FbId;
          break;
      }

      $http({
        method: (recurringId ? 'PUT':'POST'),
        url: (recurringId ? editRecurringUrl : createRecurringUrl),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode(formData)
      }).then(function(resp){
        var data = resp.data;

        cacheService.clear('autoTransfer');
        $scope.loading = false;
        if(data.Success){
          $scope.alert.successMessage = 'You\'ve scheduled a recurring transfer to ' + (transferTo.Username || transferTo.Email || transferTo.FirstName);
          $scope.alert.successShown = true;
          if(recurringId){
            $state.go('member.home.send/recurring/edit.confirmation', {recurringId: recurringId});
          } else {
            $state.go('member.home.send/recurring.step4');
          }
        } else {
          $scope.alert.alertShown = true;
        }
      }).catch(function (error){
        $scope.alert.alertShown = true;
        $scope.loading = false;
      });
    };

    // GET recurring transfer details, set datepicker accordingly
    var getAutoSettings = function(){
      var editUrl = baseURI + 'card/transfer/auto/' + recurringId;
      editRecurringUrl = editRecurringUrl + recurringId;
      $http.get(editUrl).then(function (resp){
        transfer = resp.data.Data;

        var freqKey = transfer.Frequency;
        var freqLabel, startDate;

        // Preset formdata to these autosettings
        $scope.formData.Amount = transfer.TransferAmount;
        $scope.formData.ToUsername = transfer.ToUsername;
        $scope.formData.Status = transfer.Status;

        $scope.transferTo.Type = 'akimbo';
        $scope.transferTo.Username = transfer.ToUsername;
        $scope.transferTo.FirstName = transfer.ToFirstName;
        $scope.transferTo.LastName = transfer.ToLastName;

        // Set bank and source
        for(var a = 0; a < $scope.sources.length; a++){
          if($scope.sources[a].Id == transfer.FromBankAccount){
            $scope.formData.Source = $scope.sources[a];
            break;
          }
        }

        switch (freqKey){
          case 'M':
            freqKey = 'O';
            break;
          case 'W':
            freqKey = 'E';
            break;
        }

        // Get the correct label for frequency
        switch(freqKey){
          case 'E':
            freqLabel = 'Every Week';
            break;
          case 'F':
            freqLabel = 'Every 2 Weeks';
            break;
          case 'O':
            freqLabel = 'Once a Month';
            break;
          case 'T':
            freqLabel = 'Twice a Month';
            break;
        }

        // Initialize the frequency object
        $scope.datePicker.frequency = {
          key: freqKey,
          label: freqLabel
        };

        // Get the dayoptions for the frequency
        var freqOptions = recurringTransferService.setDayOptions(freqKey);
        $scope.dayOptions = freqOptions.dayOptions;

        if(freqKey == 'T' || freqKey == 'O'){
          $scope.datePicker.day1 = freqOptions.dayOptions[(transfer.RepeatDay1 - 1)];
          $scope.datePicker.day2 = freqOptions.dayOptions[(transfer.RepeatDay2 - 1)];
        } else {
          $scope.datePicker.day1 = freqOptions.dayOptions[transfer.RepeatDay1];
          $scope.datePicker.day2 = freqOptions.dayOptions[transfer.RepeatDay2];
        }

        // Get the dateOptions for these days
        var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
        $scope.dateOptions = dateOptions;

        // Set the dateSelect to empty string
        $scope.datePicker.dateSelect = '';

        // format startdate to correct date object
        startDate = transfer.TransferStartDate + ' 12:30:00';

        for(var i = 0; i < dateOptions.length; i++){
          if(dateOptions[i].formattedDate == startDate){
            $scope.datePicker.dateSelect = dateOptions[i];
            break;
          }
        }

        // If dateselected is empty create and set the dateoption object
        if($scope.datePicker.dateSelect === ''){
          $scope.datePicker.dateSelect = startDate;
          var option = {
            key: moment(startDate).format('l'),
            label: moment(startDate).format('dddd, MMMM DD YYYY'),
            formattedDate: startDate
          };
          $scope.dateOptions.unshift(option);
          $scope.datePicker.dateSelect = option;
        }

        // Update the scheule text
        $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
      });
    };


    // Get user's linked bank accounts
    var getBanks = function (){
      $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
        $scope.sources = resp.data.Data || [];
        $scope.sources.unshift(sourceCard);
      }).then(function(){
        if(recurringId){
          getAutoSettings();
        } else {
          $scope.formData.Source = sourceCard;
        }
      });
    };

    // Initiate with a search or autosettings
    if(recurringId){
      getBanks();
    } else {
      $scope.search('');
    }
  }]);
